SA.Olark = {
    available: false,
    callbacks: [],

    initialize() {
        var email = SA.User.getEmailAddress();

        if (SA.Env.isLocal) {
            return;
        }

        ;(function(o,l,a,r,k,y){if(o.olark)return;
        r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0];
        y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r);
        y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)};
        y.extend=function(i,j){y("extend",i,j)};
        y.identify=function(i){y("identify",k.i=i)};
        y.configure=function(i,j){y("configure",i,j);k.c[i]=j};
        k=y._={s:[],t:[+new Date],c:{},l:a};
        })(window,document,"static.olark.com/jsclient/loader.js");

        this.initEvents();

        olark.configure('system.hb_position', 'right');
        olark.configure('system.hb_primary_color', '#1779e8');
        olark.configure('system.is_single_page_application', true);

        olark.identify('5351-404-10-2245');

        if (email) {
            olark('api.visitor.updateEmailAddress', {emailAddress: email});
        }
    },

    hide() {
        olark('api.box.hide');
    },

    initEvents() {
        olark('api.chat.onOperatorsAvailable', () => {
            this.setAvailable(true);
            this.hide();
        });

        olark('api.chat.onOperatorsAway', () => this.setAvailable(false));
        olark('api.box.onShrink', () => this.hide());
    },

    isAvailable() {
        return this.available;
    },

    onAvailabilityChange(cb) {
        this.callbacks.push(cb);
    },

    openChat() {
        olark('api.box.expand');
    },

    setAvailable(available) {
        this.available = available;

        this.callbacks.forEach(cb => cb());
    }
};